import React, { useRef } from 'react';
import { Box, Container, Typography, Stack, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const CTASection: React.FC = () => {
  const navigate = useNavigate();
  const videoRef = useRef<HTMLVideoElement>(null);
  
  const discordFont = {
    fontFamily: '"Inter", "Segoe UI", "Roboto", sans-serif',
    fontWeight: 800,
    letterSpacing: '-0.02em',
  };

  return (
    <Box
      sx={{
        py: { xs: 12, md: 20 },
        position: 'relative',
        overflow: 'hidden',
        minHeight: { xs: '200px', md: '600px' },
        display: 'flex',
        alignItems: 'center',
      }}
    >
      {/* Video Background */}
      <video
        ref={videoRef}
        autoPlay
        muted
        loop
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: 0,
        }}
      >
        <source 
          src="https://salmon-selective-jackal-307.mypinata.cloud/ipfs/bafybeihi7rqki34sfpwvqno3gxthnnvchmsc2biucsd4aiyjzll4c7l7mq" 
          type="video/mp4" 
        />
        {/* Fallback image if video doesn't load */}
        <img 
          src="https://images.unsplash.com/photo-1495474472287-4d71bcdd2085?ixlib=rb-4.0.3&auto=format&fit=crop&w=1920&q=80" 
          alt="Community background" 
        />
      </video>
    </Box>
  );
};

export default CTASection;